import { TextInput } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { FileManagementModal } from './FileManagementModal';
import { useFileUploadActions } from '../../hooks/file-uploads/useFileUploadActions';
import { UploadedFile } from '../../hooks/file-uploads/types';

type RenameFolderModalProps = {
  opened: boolean;
  onClose: () => void;
  folder: UploadedFile;
  onRename?: () => void;
};

export function RenameFolderModal({ opened, onClose, folder, onRename }: RenameFolderModalProps) {
  const [folderName, setFolderName] = useState(folder.file.fileName);
  const [isRenaming, setIsRenaming] = useState(false);
  const { renameFolder } = useFileUploadActions();

  useEffect(() => {
    setFolderName(folder.file.fileName);
  }, [folder.file.fileName]);

  const handleClose = () => {
    setFolderName(folder.file.fileName);
    setIsRenaming(false);
    onClose();
  };

  const handleConfirm = async () => {
    setIsRenaming(true);
    try {
      await renameFolder(folder, folderName);
      onRename?.();
      handleClose();
    } finally {
      setIsRenaming(false);
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFolderName(event.target.value);
  };

  return (
    <FileManagementModal
      opened={opened}
      onClose={handleClose}
      title="Rename folder"
      subtitle="Please enter a new name for this folder."
      icon={<IconPencil size={24} />}
      onConfirm={handleConfirm}
      confirmDisabled={!folderName.trim() || folderName.trim() === folder.file.fileName}
      confirmLoading={isRenaming}
    >
      <TextInput
        label="Folder name"
        value={folderName}
        onChange={handleNameChange}
        placeholder="e.g. June meeting summary"
        data-autofocus
        styles={{
          label: {
            fontWeight: 500,
          },
        }}
      />
    </FileManagementModal>
  );
}